import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

const halfSizeHandler = (value, correspondingHalfsizeElements) => {
    if (!['', 'unknown'].includes(value)) {
        correspondingHalfsizeElements.forEach((correspondingElement) => {
            toggleAllInputsInContainer(correspondingElement, true);
            correspondingElement.classList.remove('d-none');
        });
    } else {
        correspondingHalfsizeElements.forEach((correspondingElement) => {
            toggleAllInputsInContainer(correspondingElement, false);
            correspondingElement.classList.add('d-none');
        });
    }
};

export const halfSizeListener = () => {
    const halfSizeChangeElements = [...document.querySelectorAll('.js-change-halfsize')].filter(
        (el) => !el.dataset.halfsizeInitialized
    );

    halfSizeChangeElements.forEach((select) => {
        const correspondingHalfsizeElements = document.querySelectorAll(
            `.js-option-half-size[data-half-size-for="${select.dataset.halfSizeFor}"]`
        );

        select.addEventListener('change', () => {
            halfSizeHandler(select.value, correspondingHalfsizeElements);
        });

        halfSizeHandler(select.value, correspondingHalfsizeElements);

        select.dataset.halfsizeInitialized = true;
    });
};
